import React                      from 'react';

import { CloseVector            } from 'src/components/vector/close';

import { Container,
         PDFArea,
         XLSXArea,
         Label,
         Close,
         AttachmentDOCVariants,
         attachmentdoc_variants } from 'src/components/features/inspection/edit/attachment-doc/ui';

import * as types                 from 'src/services/api/types';
import Util                       from 'src/services/util';

import { useAppDispatch,
         storeApi               } from 'src/store';



type Props = {
  variant: AttachmentDOCVariants;
  doc: types.inspection.PieceFile | types.inspection.DefectFile;
  source: 'piece' | 'inspection';
  isAllowDelete: boolean;
  onDelete?: (guid: string) => void;
}
export const AttachmentDOC: React.FC<Props> = ({ variant, doc, source, isAllowDelete, onDelete }) => {
  const lookAndFeel = attachmentdoc_variants.get(variant)!;
  const dispatch = useAppDispatch();

  const isPDF = Util.getFileExt(doc.name).toUpperCase() === 'PDF';
  const isXLSX = Util.getFileExt(doc.name).toUpperCase() === 'XLSX';

  const onDeleteHandler = () => {
    if (onDelete !== undefined)
    {
      onDelete(doc.guid);
    }
  }

  const onDownloadDOC = () => {
    if (doc.__dataUrl !== undefined)
    {
      const a = document.createElement("a");
      a.href = doc.__dataUrl;
      a.download = doc.name;
      a.click();
    }
    else
    {
      dispatch(storeApi.inspection.edit.async.viewDOCAsync({
        fileName: doc.name,
        guid: doc.guid,
        source
      }))
        .unwrap()
        .then((result) => {
          
        })
        .catch((error) => { });
    }
  }

  return (
    <Container lookAndFeel = { lookAndFeel }>
      {isPDF && (
        <PDFArea lookAndFeel = { lookAndFeel } onClick = { onDownloadDOC } />
      )}
      {isXLSX && (
        <XLSXArea lookAndFeel = { lookAndFeel } onClick = { onDownloadDOC } />
      )}
      {isAllowDelete && 
        <Close lookAndFeel = { lookAndFeel } onClick = { onDeleteHandler }>
          <CloseVector />
        </Close>
      }
      <Label lookAndFeel = { lookAndFeel }>
        <div>
          { doc.name }
        </div>
      </Label>
    </Container>
  );
}
